import { HttpParams } from '@angular/common/http';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { WipperozApiService } from 'app/wipperoz-core/services/wipperoz-api.service';
import { QueryOptions } from 'app/wipperoz-core/types/content/query-options.model';
import { BehaviorSubject, of } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Announcement } from './announcements/types/announcement.model';
import { News } from './news/types/news.model';

import { isNil, propEq, find } from 'ramda';

@Injectable({
  providedIn: 'root'
})
export class PressService {
  onNewsChanged: BehaviorSubject<News[]>;
  onAnnouncementChanged: BehaviorSubject<Announcement[]>;
  news: News[] = [];
  totalCount = 0;

  options: QueryOptions = {
    page: 1,
    pageSize: 6
  };

  constructor(private wipperozApiService: WipperozApiService, @Inject(LOCALE_ID) private localeId: string) {
    this.onNewsChanged = new BehaviorSubject<[]>([]);
    this.onAnnouncementChanged = new BehaviorSubject<[]>([]);
  }

  getNews(options: QueryOptions): Promise<News[]> {
    let params = new HttpParams();
    params = params.append('language', this.localeId.toLocaleUpperCase());
    params = params.append('pageSize', options.pageSize);
    params = params.append('page', options.page);

    return new Promise((resolve, reject) => {
      this.wipperozApiService
        .get('/resources/news', params)
        .pipe(filter((response: any) => response !== undefined))
        .subscribe((response: any) => {
          if (isNil(response)) {
            this.onNewsChanged.next([]);
            resolve([]);
          } else {
            this.news = [];
            response.items.map((item: News) => {
              if (!find(propEq('newsId', item.newsId), this.news)) {
                this.news.push(item);
              }
            });
            this.totalCount = response.totalCount;
            this.onNewsChanged.next(this.news);
            resolve(this.news);
          }
        }),
        (err) => {
          of(`I caught: ${err}`);
          return reject;
        };
    });
  }

  getAnnouncements(startLimit: number, endLimit: number): Promise<Announcement[]> {
    let params = new HttpParams();
    params = params.append('language', this.localeId.toLocaleUpperCase());
    params = params.append('startLimit', startLimit);
    params = params.append('endLimit', endLimit);
    return new Promise((resolve, reject) => {
      this.wipperozApiService
        .get<Announcement[]>('/resources/announcements', params)
        .pipe(
          filter((response: Announcement[]) => {
            return response !== undefined;
          })
        )
        .subscribe((response: Announcement[]) => {
          if (response !== undefined && response.length > 0) {
            this.onAnnouncementChanged.next(response);
            resolve(response);
          } else {
            this.onAnnouncementChanged.next([]);
            resolve(undefined);
          }
        }),
        (err) => {
          of(`I caught: ${err}`);
          return reject;
        };
    });
  }
}
